/* eslint-env browser */
import PropTypes from 'prop-types';
import React, { useState, useEffect } from 'react';
import { defineMessages, injectIntl, intlShape } from 'react-intl';
import Popover from 'brastrap/common/popover/Popover';
import Link from 'brastrap/containers/link/LinkContainer';
import FacetInput from './ResultsFacetsInput';

const messages = defineMessages({
  label: { id: 'results-facets.label-menu', defaultMessage: 'Filter by:' },
});

const FacetMenu = props => {
  const [selectedFacet, setSelectedFacet] = useState(null);
  const [selectedFacetElement, setSelectedFacetElement] = useState(null);

  /**
   */
  const clearFacetSelect = () => {
    setSelectedFacet(null);
    setSelectedFacetElement(null);
  };
  /**
   * @param {Object} event
   * @param {string} id
   * @param {string} facetId
   */
  const handleChange = (event, id, facetId) => {
    props.onChange(event.target.checked, id, facetId);
    clearFacetSelect();
  };
  /**
   * @param {string} value
   * @param {element} target
   */
  const handleFacetSelect = (value, target) => {
    setSelectedFacet(previousState => (previousState === value ? null : value));
    setSelectedFacetElement(target);
  };

  useEffect(() => {
    if (props.layerIsVisible) {
      clearFacetSelect();
    }
  }, [props.layerIsVisible]);

  /**
   * @returns {XML}
   */
  const {
    facets,
    intl: { formatMessage },
  } = props;
  const STYLE_PREFIX = 'c-results-facet__item';

  return (
    <div>
      <ul className="c-results-facet c-results-facet--menu">
        {facets.length > 0 && (
          <li className="c-results-facet__title">
            {formatMessage(messages.label)}
          </li>
        )}
        {facets.map(facet => {
          const displayFacet = facet.values.length > 1;
          const limitMenuHeight = facet.values.length > 15;
          let className = STYLE_PREFIX;
          if (selectedFacet === facet.name) {
            className += ` ${STYLE_PREFIX}--selected`;
          }
          return (
            displayFacet && (
              <li
                key={facet.name}
                className={className}
                onClick={event => handleFacetSelect(facet.name, event.target)}
              >
                <Link
                  className="c-results-facet__title"
                  data-facet={facet.name}
                >
                  {facet.name}
                </Link>
                <Popover
                  onRootClick={() => clearFacetSelect()}
                  placement={['below']}
                  show={selectedFacet === facet.name}
                  target={selectedFacetElement}
                  skipOverlay
                >
                  <div
                    className={`c-menu${
                      limitMenuHeight ? ' c-menu--limit-height' : ''
                    }`}
                  >
                    <ul className="c-menu__items">
                      {facet.values.map(
                        ({ id, name, count, selected, swatch }) => {
                          const inputProps = {
                            className: 'c-menu__item',
                            id: `facet-input-${facet.id}-${id}`,
                            key: `${facet.id}-${id}`,
                            name,
                            count,
                            onChange: e => handleChange(e, id, facet.id),
                            selected,
                            swatch,
                            value: id,
                            checked: !!selected,
                          };

                          return <FacetInput {...inputProps} />;
                        }
                      )}
                    </ul>
                  </div>
                </Popover>
              </li>
            )
          );
        })}
      </ul>
    </div>
  );
};

FacetMenu.propTypes = {
  facets: PropTypes.array,
  intl: intlShape,
  onChange: PropTypes.func,
  layerIsVisible: PropTypes.bool,
};

FacetMenu.defaultProps = {
  facets: [],
};

export default injectIntl(FacetMenu);
